module.exports = __webpack_public_path__ + "static/media/bg-guru.609aeb25.png";